export default "__VITE_ASSET__C1lR$TIc__"